








































import { CourseDetails } from '@/jbi-shared/dto/jtms.dtos';
import { CourseStatus, CourseVisibility } from '@/jbi-shared/types/jtms.types';
import BaseButton from '@/jbi-shared/vue-components/BaseButton.vue';
import { CourseCreateAndUpdateButtonEventTypes } from '@/store/modules/jtms/course/course.types';
import { RootState } from '@/store/store';
import delay from 'delay';
import {
  Component,
  Emit,
  Prop,
  PropSync,
  Vue,
  Watch
} from 'vue-property-decorator';
import { Route } from 'vue-router';
import { State } from 'vuex-class';

@Component({
  components: {
    BaseButton
  }
})
export default class CourseCreationSubmitButtons extends Vue {
  @Prop(Boolean) loading!: boolean;
  @Prop(Boolean) invalid!: boolean;
  @Prop(Object) exitRoute!: Partial<Route>;
  @Prop(Boolean) isSettings!: boolean;
  @Prop({ type: Boolean, default: false }) isCoursePublished!: boolean;
  @PropSync('openForRegistration', { default: false })
  syncedOpenForRegistration!: boolean;
  @PropSync('requireRegistrationConfirmation', { default: false })
  syncedRequireRegistrationConfirmation!: boolean;
  @PropSync('visibility') syncedVisibility!: CourseVisibility;
  shouldDisable: boolean = false;

  @State(({ course }: RootState) => course.courseDetails)
  courseDetails!: CourseDetails;

  mounted() {
    this.onVisibilityChanged();
  }

  get isDraftCourse() {
    return this.courseDetails.status === CourseStatus.DRAFT;
  }

  public async handleExitCourseCreation() {
    const dialogElem: Vue = this.$buefy.dialog.confirm({
      title: `Discard Course Creation`,
      message: `All data entered will be lost once you exit this page`,
      confirmText: 'Cancel',
      canCancel: ['button'],
      onConfirm: () => undefined,
      cancelText: 'Exit',
      onCancel: () => this.$router.replace(this.exitRoute as any)
    });

    while (!dialogElem.$el?.querySelector) {
      await delay(50);
    }
    const cancelBtn = dialogElem.$el?.querySelector?.(
      `.modal-card > footer > button:first-child`
    );
    cancelBtn?.classList?.add?.(`is-red`);
  }

  /**
   * Computed boolean to track changes to the registration configs.
   * If no changes were made, save should trigger a standard SAVE_SETTTINGS event.
   * Else, it should trigger a PUBLISH_SAVE_WITH_REGISTRATION_CHANGES event.
   */
  get hasRegistrationConfigChanges() {
    return (
      this.syncedOpenForRegistration !== this.courseDetails.openForRegistration
    );
  }

  triggerSaveAsDraftOrNormalSave(isSettings: boolean) {
    if (isSettings) {
      this.saveSettings();
    } else {
      this.handleSaveAsDraft();
    }
  }

  // If not in course settings, the 'Save as Draft' button will act as a normal save.
  triggerExitCourseCreationOrCancelCourse(isSettings: boolean) {
    if (isSettings) {
      this.handleCancelCourse();
    } else {
      this.handleExitCourseCreation();
    }
  }

  @Watch('syncedVisibility')
  onVisibilityChanged() {
    if (this.syncedVisibility === CourseVisibility.PRIVATE) {
      this.shouldDisable = true;
      this.syncedRequireRegistrationConfirmation = true;
    } else {
      this.shouldDisable = false;
    }
  }

  @Emit('publish-course')
  handleCreateAndPublish() {
    return CourseCreateAndUpdateButtonEventTypes.CREATE_AND_PUBLISH;
  }

  @Emit('draft-course')
  handleSaveAsDraft() {
    return CourseCreateAndUpdateButtonEventTypes.SAVE_AS_DRAFT;
  }

  @Emit('save-settings')
  saveSettings() {
    if (this.isCoursePublished && this.hasRegistrationConfigChanges) {
      return CourseCreateAndUpdateButtonEventTypes.PUBLISH_SAVE_WITH_REGISTRATION_CHANGES;
    }
    return CourseCreateAndUpdateButtonEventTypes.SAVE_SETTINGS;
  }

  @Emit('cancel-course')
  handleCancelCourse() {
    return;
  }
}
